import { useQuery } from "@tanstack/react-query";
import { queries } from "@core-shop/cache";
import { DefaultStoreFrontType } from "@core-shop/types";

export function useDefaultStorefront({ type = DefaultStoreFrontType.HOME_DEFAULT, enabled = true } = {}) {
  return useQuery({ ...queries.defaultStorefrontByType(type), enabled });
}
